export default __webpack_public_path__ + "static/media/t-img.622769c6.png";